'use client';

import { useTranslations } from 'next-intl';
import { BaseLineLeft } from '@/app/components/icons/BaseLineLeft';
import { BaseLinePackup } from '@/app/components/icons/BaseLinePackup';
import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import { CLAW_LOGO_IMAGE_URL } from '@/app/constants';
import { useRouter } from '@/i18n/routing';

interface NavHeaderProps {
  onToggleCollapse: () => void;
}

export const NavHeader = ({ onToggleCollapse }: NavHeaderProps) => {
  const t = useTranslations();
  const router = useRouter();

  const handleBrandClick = () => {
    router.push('/home/recommend');
  };

  return (
    <div className="flex h-[53px] items-center justify-between px-3">
      <div className="flex cursor-pointer items-center gap-2" onClick={handleBrandClick}>
        <BaseLineLeft className="size-5 text-system-white36" />
        <div className="size-7 overflow-hidden rounded-full bg-white">
          <img src={CLAW_LOGO_IMAGE_URL} alt={t('claw.nav.brand')} className="size-full object-cover" />
        </div>
        <span className="font-semibold text-xl">{t('claw.nav.brand')}</span>
      </div>
      <CustomTooltip content={t('sidebar.collapseMenu')} side="right" disableHoverableContent={true}>
        <button
          type="button"
          className="flex size-8 items-center justify-center rounded-10 text-system-white64 transition-colors hover:bg-system-white08 hover:text-system-white"
          onClick={onToggleCollapse}
          aria-label={t('sidebar.collapseMenu')}
          title={t('sidebar.collapseMenu')}
        >
          <BaseLinePackup className="rotate-180 text-inherit text-lg" />
        </button>
      </CustomTooltip>
    </div>
  );
};
